module.exports = __webpack_public_path__ + "static/media/dashboard.d6faebc5.svg";